import { Grid } from '@mui/material';
import React from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { textValue } from '../../../../../../pages/dashboard/tradedocuments/salescontract/textVallue';
import UploadStamp from '../../../common/UploadStamp';
import Signature from '../../../../../signature/signature';
import { SalesContractPayload } from '../../../../../../pages/dashboard/tradedocuments/tradeDocumentTypes/SslesContracyInterface';

const StepTwo = ({
    payload,
    updateField,
    setSignatureUrlBase64Exporter,
    signatureUrlBase64Exporter
}: {
    updateField: (name: string, value: unknown) => void;
    payload: SalesContractPayload;
    setSignatureUrlBase64Exporter: (value: string) => void;
    signatureUrlBase64Exporter: string;
}) => {
    const handleTextChange = (html?: any) => {
        updateField('additionalInfo', html);
    };
    return (
        <>
            <Grid item xs={12} md={12} lg={12} className='mt-2'>
                <p className='py-4 text-appcolorblackthree'>
                    Additional Information
                </p>
                <ReactQuill
                    theme='snow'
                    value={payload?.additionalInfo || textValue}
                    onChange={handleTextChange}
                    style={{
                        width: '100%',
                        minHeight: '300px',
                        opacity: 0.8
                    }}
                    formats={[
                        'header',
                        'font',
                        'size',
                        'bold',
                        'italic',
                        'underline',
                        'strike',
                        'blockquote',
                        'list',
                        'bullet',
                        'indent',
                        'link',
                        'image',
                        'video'
                    ]}
                />
            </Grid>
            <Grid item xs={12} md={6} lg={6}>
                <div className='flex gap-2 items-center mt-4 mb-4 lg:mb-0'>
                    <UploadStamp
                        {...{ payload, updateField }}
                        name="Exporter's Stamp Image"
                    />
                </div>
            </Grid>
            <Grid container spacing={2} className='py-3'>
                <Grid item xs={12} md={6} lg={6}>
                    <div className='w-full'>
                        <Signature
                            label='Exporter Signature'
                            name='exporterSignature'
                            updateField={updateField}
                            setSignatureUrlBase64={
                                setSignatureUrlBase64Exporter
                            }
                            signatureUrlBase64={signatureUrlBase64Exporter}
                        />
                    </div>
                </Grid>
            </Grid>
        </>
    );
};

export default StepTwo;
